<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{initData.sa_code}}&nbsp;#{{initData.sd_detno}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.sa_custname}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value">{{initData.sa_seller}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.sa_pocode">
            <label class="weui-form-preview__label">客户订单</label>
            <span class="weui-form-preview__value">{{initData.sa_pocode}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_orispeccode">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_spec">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="initData.pr_brand">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">
              <span v-format="'#,##0.#'">{{initData.sd_qty}}</span>
              &nbsp;
              {{initData.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已出货</label>
            <span class="weui-form-preview__value">
              <span v-format="'#,##0.#'">{{initData.sd_pdsendqty}}</span>
              &nbsp;
              {{initData.pr_unit}}
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sd_delivery}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税单价({{initData.sa_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.####'">{{initData.sd_netprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价({{initData.sa_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.####'">{{initData.sd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税金额({{initData.sa_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sd_nettotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率(%)</label>
            <span class="weui-form-preview__value">{{initData.sd_taxrate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税额({{initData.sa_currency}})</label>
            <span
              class="weui-form-preview__value"
              v-format="'#,##0.00'"
            >{{initData.sd_total-initData.sd_nettotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">价税合计({{initData.sa_currency}})</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.sd_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>